/*
 * @Author: cn1994
 * @Date: 2023-09-17 14:39:30
 * @LastEditors: cn1994
 * @LastEditTime: 2023-09-18 17:42:21
 * @Description: file content
 */
import { defineStore } from 'pinia'

export const useMenuStore = defineStore('menuStore', {

  state: () => {
    return {
      // 当前菜单路由
      menuPath: "/home",
      // 菜单列表
      menuList: [],
      // 当前iframe页面url
      menuJumpUrl: "",
      // 非菜单其他特殊跳转  iframe及打开新窗口的
      otherJumpUrl: {},
      // 当前选中的菜单
      menuActive: '',
      //2.0到3.1切换后刷新菜单
      changeVersion: false,
      //校区的campusId
      campusId:'',
      //支付完成后跳转的页面
      pageURL:'',
      // 当前history长度
      rLen: 0
    }
  },
  getters: {

  },
  actions: {
    updateMenuPath(data) {
      this.menuPath = data;
    },
    updateMenuJumpUrl(data) {
      this.menuJumpUrl = data;
    },
    updateMenuList(data) {
      this.menuList = data;
    },
    updateOtherJumpUrl(data) {
      this.otherJumpUrl = data;
    },
    setMenuActive(data) {
      this.menuActive = data
    },
    setchangeUpdat(data){
      this.changeVersion = data
    },
    setcampusId(data){
      this.campusId = data
    },
    setpageURL(data){
      this.pageURL = data
    }

  },
  persist:
  {
    storage: sessionStorage,
    enabled: true
  }
})